import checkout from "./form";

const {
  formField: {
    checkbox1,
    checkbox2,
    checkbox3,
    address,
    contract,
    district,
    email,
    fax,
    firstTime,
    phone,
    province,
    supplementaryForThe,
    taxCalculationPeriod,
    taxId,
    taxId2,
    taxId3,
    taxpayerName,
    unitType,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [checkbox3.name]: false,
  [address.name]: false,
  [taxCalculationPeriod.name]: "",
  [unitType.name]: "",
  [district.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [email.name]: "",
  [fax.name]: "",
  [phone.name]: "",
  [taxpayerName.name]: "",
  [taxId.name]: "",
  [contract.name]: "",
  [taxId2.name]: "",
  [province.name]: "",
  [taxId3.name]: "",
};

export default initialValues;
